import React from 'react';
import { Link } from 'react-router-dom';
import { SupportLayout } from './SupportLayout';

export const SafetyPage: React.FC = () => {
  return (
    <SupportLayout
      title="Safety"
      subtitle="What we do, what we expect from hosts, and what to do if something goes wrong."
    >
      <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-3">For guests</h2>
      <ul className="space-y-3 text-gray-700">
        <li>
          <strong className="text-gray-900">Money is held until check-in.</strong> If the place is wrong, you call
          us and get refunded.
        </li>
        <li>
          <strong className="text-gray-900">Hosts are vetted in person.</strong> We visit each property before it
          goes live, photograph it, and check the title.
        </li>
        <li>
          <strong className="text-gray-900">ID is required.</strong> Both you and the host are verified before
          booking.
        </li>
        <li>
          <strong className="text-gray-900">A real human is reachable.</strong> WhatsApp or call the Beirut team
          24/7.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-3">For hosts</h2>
      <ul className="space-y-3 text-gray-700">
        <li>
          <strong className="text-gray-900">Damage cover up to $1,000,000 per stay.</strong> Send photos and a short
          description; we file the claim.
        </li>
        <li>
          <strong className="text-gray-900">Guest IDs verified before booking.</strong> No anonymous reservations.
        </li>
        <li>
          <strong className="text-gray-900">Set your own house rules.</strong> No parties, no pets, no smoking. Your
          call.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-3">If something goes wrong</h2>
      <ol className="space-y-3 text-gray-700 list-decimal pl-5">
        <li>Take photos and notes the moment you notice the issue.</li>
        <li>
          Reach out to the host through the message thread on your booking. Most things resolve right there.
        </li>
        <li>
          If the host doesn't respond within an hour, or the issue is urgent,{' '}
          <Link to="/contact" className="text-primary-600 underline">
            contact us
          </Link>
          . Reference your booking code.
        </li>
      </ol>

      <h2 className="text-2xl font-semibold text-gray-900 mt-10 mb-3">Emergencies</h2>
      <p className="text-gray-700">
        For medical, fire, or police emergencies, call <strong>112</strong> in Lebanon first. Then message us so we
        can support you and contact the host.
      </p>

      <div className="mt-12 p-6 bg-primary-50 rounded-2xl">
        <p className="text-gray-900 font-medium mb-2">Spotted something off?</p>
        <p className="text-gray-600 mb-4">
          A listing that looks fake, a host pressuring you off-platform, or anything that feels wrong: tell us and
          we'll investigate.
        </p>
        <Link
          to="/contact"
          className="inline-block px-6 py-3 bg-primary-500 text-white font-semibold rounded-xl hover:bg-primary-600 transition-colors"
        >
          Report an issue
        </Link>
      </div>
    </SupportLayout>
  );
};

export default SafetyPage;
